export const stringsKey = "IVRFlowWizardStepper";
export const englishStrings = {
	deleteWidgetTooltip: "Delete Widget",
	widgetDeleteConfirmationMessage: "Are you sure you want to delete widget?",
};
